exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "a.disabled[data-v-f230b840]:hover,li.disabled[data-v-f230b840]:hover{color:hsla(0,0%,56%,.4)}", "", {"version":3,"sources":["/Users/zeedog/Documents/Projects/zeedog-oms/theme/zeedog-omb-vue/src/components/SidebarMenu.vue"],"names":[],"mappings":"AACA,qEAAqE,uBAA2B,CAC/F","file":"SidebarMenu.vue","sourcesContent":["\nli.disabled[data-v-f230b840]:hover,a.disabled[data-v-f230b840]:hover{color:rgba(144,144,144,0.4)\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f230b840","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SidebarMenu.vue
// module id = 373
// module chunks = 0